export enum CouponType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}
